import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { FilledSelect } from "../../components/FormElements";
import {
  FirmwarePackageSelect,
  GeofencePackageSelect,
} from "../../components/FormElements/BinaryPackageSelect";

const TargetPackageField = (props) => {
  const { packageType, defaultFirmware, defaultGeofence } = props;
  const { t } = useTranslation();

  let Component = FilledSelect;

  if (packageType === "Firmware") {
    Component = FirmwarePackageSelect;
  }

  if (packageType === "Geofence") {
    Component = GeofencePackageSelect;
  }

  return (
    <Component
      label={t("Components.FormControls.TargetPackage")}
      FormControlProps={{
        variant: "outlined",
        margin: "dense",
        size: "small",
        fullWidth: true,
      }}
      fleetDefault={packageType === "Firmware" ? defaultFirmware : defaultGeofence}
      {...props}
    />
  );
};

TargetPackageField.propTypes = {
  packageType: PropTypes.oneOf(["Firmware", "Geofence", ""]),
  defaultFirmware: PropTypes.string,
  defaultGeofence: PropTypes.string,
  geofencePackages: PropTypes.array.isRequired,
  firmwarePackages: PropTypes.array.isRequired,
};

TargetPackageField.defaultProps = {
  packageType: null,
  defaultFirmware: PropTypes.string,
  defaultGeofence: PropTypes.string,
};

export default TargetPackageField;
